import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "toFuncIdentity",
  standalone: false
})
export class ToFuncIdentityPipe implements PipeTransform {
  transform(value: any): () => any {
    return () => value;
  }
}
